import { render, staticRenderFns } from "./msg-box.vue?vue&type=template&id=6b5827b4&scoped=true"
import script from "./msg-box.vue?vue&type=script&lang=js"
export * from "./msg-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5827b4",
  null
  
)

export default component.exports